import { Schema, arrayOf } from 'normalizr'

export const tax = new Schema('taxes')
export const arrayOfTaxes = arrayOf(tax)
